<template>
  <div id="dialogLayerOut" class="backdrop">
    <loader></loader>
    <div class="container">
      <div class="row">
        <div class="col-12">
          <slot />
        </div>
      </div>
    </div>
    <div class="fixed-footer">
      <div class="row align-items-center">
        <div class="col">
          <img src="../assets/images/Sinchii_RGB_Logo_White.png" class="logo" width="102" />
        </div>
        <div class="col text-end version">
          <!-- Version -->
          <version></version>
        </div>
      </div>
    </div>
    <section v-if="isOrganisationWizard" class="device-breakpoint org-wizard">
      <div class="dialog-container dialog-light importSetup">
        <div class="dialog dialog-md">
          <div class="text-center mb-5">
            <h2 style="color: #f26a3e; font-weight: 700; font-size: 1.5rem; margin: 0;">
              Thank you for signing up with Sinchii!
            </h2>
          </div>
          <ax-dialog-header
            text=""
            :type="'mascot-laptop'"
            :description="'To setup your organisation and get started, please log out and switch to a laptop or desktop device.'"
          ></ax-dialog-header>
          <div class="dialog-body">
            <div class="import-group">
              <div class="mt-2">
                <k-button variant="secondary" class="btn btn-lg btn-secondary w-100 mb-2" @click="logOut">
                  Log Out
                </k-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section v-else-if="!isMobileFriendlyRoute" class="device-breakpoint">
      <div
        class="content row justify-content-center h-100vh align-items-center"
      >
        <div class="col-12 col-lg-6 text-center py-5">
          <div class="mb-5 p-2">
            <img
              class="image" src="../assets/images/breakpoint-graphic.png"
            />
          </div>
          <div class="text-white">
            <h1 class="mb-3 text-white">
              This screen size is not supported yet.
            </h1>
            <p class="font-weight-semi-bold">
              Please switch to your laptop or desktop (or rotate your device if you are on a tablet) to use Sinchii.
            </p>
          </div>
          <div v-if="isLoggedIn" class="mt-2">
            <k-button variant="secondary" class="btn btn-lg btn-secondary w-100 mb-2" @click="logOut">
              Log Out
            </k-button>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
  import Loader from "../components/Loader.vue";
  import store from "@/store";
  import eventBus from "@/eventBus";
  import AuthService from "../services/auth-service";

  export default({
    name: "dialogLayout",
    components: {
      Loader
    },
    data() {
      return {
        orgWizardStep: null
      }
    },
    computed: {
      isMobileFriendlyRoute() {
        const mobileFriendlyRoutes = ["/login", "/signup", "/resetpassword", "/finalise", "/invalidlink"];
        const is2fa = this.$route.path.toLowerCase() === "/signupbusinessinfo" && this.orgWizardStep && this.orgWizardStep === 'twoFactorAuth';
        return mobileFriendlyRoutes.includes(this.$route.path.toLowerCase()) || is2fa;
      },
      isOrganisationWizard() {
        return this.$route.path.toLowerCase() == "/signupbusinessinfo" && this.orgWizardStep && this.orgWizardStep === 'orgWizard';
      },
      isLoggedIn() {
        return store.getters.isLoggedIn;
      }
    },
    mounted() {
      eventBus.on('org-wizard-step-change', this.stepChange);
    },
    beforeUnmount() {
      eventBus.off('org-wizard-step-change', this.stepChange);
    },
    methods: {
      async logOut() {
        eventBus.emit('close-all-popups');
        await AuthService.logout();
        this.$router.push("/login");
      },
      stepChange(step) {
        this.orgWizardStep = step;
      }
    }
})
</script>
